import { injectable, inject } from 'inversify'
import type { Resolvable } from '@/services/resolvers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type BaseModel from '@/data/models/BaseModel'
import type DomainManagerService from '@/services/domain/domainManagerService'

export type CleanModelsResolverParams = {
  models: (typeof BaseModel)[]
}

@injectable()
export default class CleanModelsResolver implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.DomainManagerService) protected readonly domainManagerService: DomainManagerService,
  ) {}

  public async resolve() {
    // do nothing
  }

  public async unresolve(params: CleanModelsResolverParams) {
    if (params.models?.length === 0) {
      return
    }

    for (const model of params.models) {
      this.domainManagerService.getService(model).deleteAllFromStore()
    }
  }
}
